import Tibbit43Node from '@appblocks/codegeneration/Nodes/Tibbit43Node';
import { Setting, SettingType } from '@appblocks/codegeneration/types';

export default class Tibbit43_1Node extends Tibbit43Node {
    constructor() {
        super();
        this.name = 'Tibbit 43_1';
        this.id = 'node_tibbit_43_1';
        this.linkedFeature = 'tibbit_43_1';
        this.description = '4-Channel Streaming ADC ±10V';

        const settings: Setting[] = [
            {
                id: 'TIBBIT',
                name: 'Tibbit',
                settingType: SettingType.OPTION,
                required: true,
                refId: 'tibbit_43_1',
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }
}
